// Third party
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';
import { useForm, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// Components
import { WelcomeWrapper } from '@mgm/common/wrappers';
import { GenericHeader } from '@mgm/common/components/base';
import { BackToLogin } from '@mgm/common/components';
import { NavLink } from 'react-router-dom';
import { EmailField, TCustomFieldOptions, TFormInputs } from '../../../components/form';
import { LanguageSelect } from '../../../components';

// Hooks
import { useForgotAPI } from '../../../hooks/api';

export const ForgotPassword = () => {
  const { t } = useTranslation(['welcome', 'warning']);

  const methods = useForm<Pick<TFormInputs, TCustomFieldOptions>>({
    mode: 'all',
  });

  const {
    mutate: forgotMutate, isLoading,
  } = useForgotAPI();

  const handleForgotPass = (data: Pick<TFormInputs, 'email'>) => {
    if (data?.email?.length) forgotMutate(data.email || '');
  };

  const isEmbedded = window !== window.parent;

  const content = (
    <>
      <LanguageSelect />
      <GenericHeader
        subtitleProps={{
          children: t('forgotSubtitle'),
          fontSize: 14,
        }}
        titleProps={{
          children: t('resetPassword'),
        }}
      />
      <form
        noValidate
        onSubmit={methods.handleSubmit(handleForgotPass)}
      >
        <Stack spacing={3}>
          <FormProvider {...methods}>
            <EmailField />
          </FormProvider>
        </Stack>
        <Box paddingY={2}>
          <LoadingButton
            type="submit"
            loading={isLoading}
            disabled={!methods.formState.isValid || isLoading}
            fullWidth
            variant="contained"
            sx={{ mt: 1, mb: 2 }}
          >
            {t('sendInstructions')}
          </LoadingButton>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          paddingTop={2}
        >
          <BackToLogin NavLinkComponent={NavLink as never} btnText={t('backToLogin')} />
        </Box>
      </form>
    </>
  );

  return isEmbedded ? content : <WelcomeWrapper>{content}</WelcomeWrapper>;
};
